import '/modules/extended_report/css/tumboExtendedReport.css';
import '/modules/extended_report/css/tumboExtendedReport.responsive.css';
import * as $ from "jquery";
import {ExtendedReportConfig, ExtendedReportRuntimeConfig} from "./config/ExtendedReportConfig";
import {ModalFull} from "../common/ui/Modal";
import {Indicator} from "./layer/Indicator";
import {SettingsSelector} from "./timeseries /SettingsSelector";
import {dateFromStr, formatDate} from "../common/time/TimeCalculator";
import {GDORDrIaChart} from "./timeseries /GDORDrIaChart";
import {MapImgNavigatableIndicatorChart} from "./timeseries /MapImgNavigatableIndicatorChart";
import {FAPANChart} from "./timeseries /FAPANChart";
import {SMIANChart} from "./timeseries /SMIANChart";
import {SPIChart} from "./timeseries /SPIChart";
import {RainChart} from "./timeseries /RainChart";
import {DatePicker} from "../common/timeseries/DatePicker";
import {LandAndClimateClassificationContainer} from "./timeseries /LandAndClimateClassificationContainer";
import {PrecipitationChart} from "./timeseries /PrecipitationChart";
import {MainTumboApplication} from "../common/main/MainTumboApplication";

/**
 * The extended report application point of entry
 * @extends MainTumboApplication
 * @hideconstructor
 */
class TumboExtendedReport extends MainTumboApplication {

    constructor(translations, config, targetId, logger) {
        super(translations, config, targetId, logger);
        this.mainIndicators = [];
        this.precepIndicators = [];
        this.otherIndicators = [];
        this.mainIndicatorCharts = [];
        this.precepIndicatorCharts = [];
        this.otherIndicatorCharts = [];
    }

    getClassName() {
        return "TumboExtendedReport";
    }

    _readConfig() {
        return new ExtendedReportConfig(this.config);
    }

    _getRuntimeConfigSerializationKey() {
        return 'reportRuntimeConfig_' + this.parsedConfig.getCode();
    }

    _getRuntimeConfig() {
        return new ExtendedReportRuntimeConfig(this.parsedConfig.getCode(), undefined);
    }

    _getRuntimeConfigFromSerialization(runtimeConfigSerialization) {
        return ExtendedReportRuntimeConfig.createFromSerialized(this.parsedConfig.getCode(), runtimeConfigSerialization);
    }

    _doRun() {
        this.target.addClass('drought-extended-report');
        this._initWarnings();

        this.layerInfoModal = new ModalFull(this.translator, this.isMobileDevice, this.target, 'layer_info_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());

        const urlSearchParams = new URLSearchParams(window.location.search);
        let coords;
        if (urlSearchParams.get('lon') && urlSearchParams.get('lat')) {
            coords = [Number(urlSearchParams.get('lon')), Number(urlSearchParams.get('lat'))];
        }

        this._initIndicators();

        this.date = dateFromStr(urlSearchParams.get('date'));
        if (!this.date)
            this.date = this.mainIndicators[0].getTimeCalculator().getUntil();

        this._initLocationSelector(coords);
        this._initLandAndClimateClassificationContainer();

        this._initIndicatorCharts();
        this._generateDOMStructure();

        this._render();
    }

    _generateDOMStructure() {
        this.chartsContainer = $('<ul class=""></ul>');
        this.outerContent = $('<div class="outer-content"><h1>' + this.parsedConfig.getName() + '</h1></div>');
        this.target.append(this.outerContent);
        this.outerContent.append(this.chartsContainer);
    }

    _initIndicators() {
        this.mainIndicators = this.parsedConfig.getIndicatorConfigs().slice(0, 1)
            .map(ic => new Indicator(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));

        this.precepIndicators = this.parsedConfig.getIndicatorConfigs().slice(1, 3)
            .map(ic => new Indicator(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));

        this.otherIndicators = this.parsedConfig.getIndicatorConfigs().slice(3)
            .map(ic => new Indicator(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));

        this.warningsButton.onChangeVisibleLayers(this.mainIndicators.concat(this.precepIndicators).concat(this.otherIndicators))
    }

    _initIndicatorCharts() {
        this.mainIndicatorCharts = this.mainIndicators
            .map(i => new GDORDrIaChart(
                "main_ind_chart_" + i.getCode(),
                this.translator,
                this.parsedConfig.getGDORDRIAValuesUrl(),
                this.parsedConfig.getMapImagesUrl(),
                i,
                this.date,
                this.layerInfoModal,
                this.runtimeConfig,
                this.isMobileDevice,
            ));

        this.precepIndicatorCharts = this.precepIndicators
            .map(i => {
                if (i.getCode() === 'spb')
                    return new SPIChart(
                        "precep_ind_chart_" + i.getCode(),
                        this.translator,
                        i,
                        this.date,
                        this.layerInfoModal,
                        this.runtimeConfig,
                        this.isMobileDevice,
                    );
                if (i.getCode() === 'monrain')
                    return new RainChart(
                        "precep_ind_chart_" + i.getCode(),
                        this.translator,
                        i,
                        this.date,
                        this.layerInfoModal,
                        this.runtimeConfig,
                        this.isMobileDevice,
                    );
                return new PrecipitationChart(
                    "precep_ind_chart_" + i.getCode(),
                    this.translator,
                    i,
                    this.date,
                    this.layerInfoModal,
                    this.runtimeConfig,
                    this.isMobileDevice,
                );
            });

        this.otherIndicatorCharts = this.otherIndicators
            .map(i => {
                if (i.getCode() === 'fapar_anom')
                    return new FAPANChart(
                        "other_ind_chart_" + i.getCode(),
                        this.translator,
                        i,
                        this.date,
                        this.layerInfoModal,
                        this.runtimeConfig,
                        this.isMobileDevice,
                    );
                else if (i.getCode() === 'sm_anom')
                    return new SMIANChart(
                        "other_ind_chart_" + i.getCode(),
                        this.translator,
                        i,
                        this.date,
                        this.layerInfoModal,
                        this.runtimeConfig,
                        this.isMobileDevice,
                    );
                return new MapImgNavigatableIndicatorChart(
                    "other_ind_chart_" + i.getCode(),
                    this.translator,
                    i,
                    this.date,
                    this.layerInfoModal,
                    this.runtimeConfig,
                    this.isMobileDevice,
                );
            });
    }

    _initLocationSelector(coords) {
        this.coordsMapModal = new ModalFull(this.translator, this.isMobileDevice, this.target, 'coords_map_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());
        const timeCalculator = this.mainIndicators[0].getTimeCalculator();
        let minDate = this.mainIndicators[0].getDataFrom();
        for (let i = 0; i < 10; i++)
            minDate = timeCalculator.getNextDate(minDate);
        const maxDate = this.mainIndicators[0].getDataUntil();
        this.locationSelector = new SettingsSelector(
            "indicators_location_selector",
            this.translator,
            this.parsedConfig.getTownAroundPointUrl(),
            this.parsedConfig.getCountryStatsUrl(),
            this.parsedConfig.getBasicStatsUrl(),
            this.parsedConfig.getMapImagesUrl(),
            coords ? coords : this.parsedConfig.getCoordLonLatWgs84(),
            timeCalculator.fixDate(this.date),
            minDate,
            maxDate,
            timeCalculator,
            this.coordsMapModal,
            this.runtimeConfig,
            this.isMobileDevice
        );
        this.locationSelector.onChange(() => {
            this.date = this.locationSelector.getDate();
            this._updateMainIndicators();
            this._updatePrecepIndicators();
            this._updateOtherIndicators();
            this._updateLandAndClimateClassificationContainer();
            const urlSearchParams = new URLSearchParams(window.location.search);
            const coordinatesWgs84 = this.locationSelector.getCoordinatesWgs84();
            urlSearchParams.set('lon', "" + coordinatesWgs84[0]);
            urlSearchParams.set('lat', "" + coordinatesWgs84[1]);
            urlSearchParams.set('date', formatDate(this.date));
            window.history.replaceState(null, null, '//' + window.location.host + window.location.pathname + '?' + urlSearchParams.toString());
        });
    }

    _initLandAndClimateClassificationContainer() {
        this.landAndClimateClassificationContainer = new LandAndClimateClassificationContainer(
            "land_and_climate_classification",
            this.translator,
            this.isMobileDevice,
            this.runtimeConfig,
            this.parsedConfig.getRegionalClassGDORDRIAStatsUrl(),
            this.parsedConfig.getStatsDescUrl(),
            this.mainIndicators[0].getChartStyler()
        );
    }

    _updateMainIndicators() {
        this.mainIndicatorCharts.forEach(i => i.setChartParams(
            this.date,
            this.parsedConfig.getCoordLonLatWgs84(),
            this.locationSelector.getMapUrls() ? this.locationSelector.getMapUrls()['main'] : undefined,
            this.locationSelector.getAruId(),
            this.locationSelector.getRegionArea(),
            this.locationSelector.getCountryCode()
        ))
    }

    _updateOtherIndicators() {
        if (this.locationSelector.aruId)
            $.getJSON(this.parsedConfig.getOtherIndicatorsValuesUrl().format([
                this.locationSelector.getAruId(),
                formatDate(this.mainIndicators[0].getTimeCalculator().addDays(this.date, -DatePicker.MAX_DAYS)).replaceAll('-', ''),
                formatDate(this.mainIndicators[0].getTimeCalculator().addDays(this.date, 365)).replaceAll('-', '')
            ]), data =>
                this.otherIndicatorCharts.forEach(i =>
                    i.setChartParams(
                        this.date,
                        this.parsedConfig.getCoordLonLatWgs84(),
                        this.locationSelector.getMapUrls(),
                        data,
                        this.locationSelector.getRegionArea()
                    ))
            );
    }

    _updatePrecepIndicators() {
        if (this.locationSelector.aruId)
            $.getJSON(this.parsedConfig.getPrecipitationIndicatorsValuesUrl().format([
                this.locationSelector.getCoordinatesWgs84()[0] + "",
                this.locationSelector.getCoordinatesWgs84()[1] + ""
            ]), data =>
                this.precepIndicatorCharts.forEach(i => {
                    i.setUntilAndCoords(
                        this.date,
                        this.parsedConfig.getCoordLonLatWgs84(),
                        data
                    );
                })
            );
    }

    _updateLandAndClimateClassificationContainer() {
        this.landAndClimateClassificationContainer.updateDateAruId(this.date, this.locationSelector.getAruId());
    }

    _render() {
        this.chartsContainer.append(this.locationSelector.getUIElement());
        this.locationSelector.onAdd2DOM();
        this.mainIndicatorCharts.forEach(ic => {
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.precepIndicatorCharts.forEach(ic => {
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.otherIndicatorCharts.forEach(ic => {
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.chartsContainer.append(this.landAndClimateClassificationContainer.getUIElement());
        this.landAndClimateClassificationContainer.onAdd2DOM();
        this._updateMainIndicators();
        this._updatePrecepIndicators();
        this._updateOtherIndicators();
    }
}

export {TumboExtendedReport}